import { Action } from '@ngrx/store';
import { IMatchingGift } from '../../../commons';

export enum MatchingGiftActionTypes {
  LoadInitialState = '[MatchingGift] Load Initial State',
  LoadMatchingGiftState = '[MatchingGift] Load MatchingGift State',
  LoadMatchingGiftStateSuccess = '[MatchingGift] Load MatchingGift State Success',
  LoadMatchingGiftStateFail = '[MatchingGift] Load MatchingGift State Fail',
  IUDMatchingGiftState = '[MatchingGift] IUD MatchingGift State',
  IUDMatchingGiftStateSuccess = '[MatchingGift] IUD MatchingGift State Success',
  arwMatchingGift = '[MatchingGift] Approve Reject Withdrawn Matching Gift',
  arwMatchingGiftSuccess = '[MatchingGift] Approve Reject Withdrawn Matching Gift Success',
  MatchingGiftScreenErrorReset = '[MatchingGift] MatchingGift Screen Error Reset'

}

export class LoadInitialState implements Action {
  readonly type = MatchingGiftActionTypes.LoadInitialState;
  // constructor(public Id: any ) {}
}

export class LoadMatchingGiftState implements Action {
  readonly type = MatchingGiftActionTypes.LoadMatchingGiftState;
  constructor(public Id: any ) {}
}

export class LoadMatchingGiftStateSuccess implements Action {
  readonly type = MatchingGiftActionTypes.LoadMatchingGiftStateSuccess;
  constructor(public payload: IMatchingGift ) {}
}

export class LoadMatchingGiftStateFail implements Action {
  readonly type = MatchingGiftActionTypes.LoadMatchingGiftStateFail;
  constructor(public payload: any) {}
}

export class IUDMatchingGiftState implements Action {
  readonly type = MatchingGiftActionTypes.IUDMatchingGiftState;
  constructor(public payload: IMatchingGift, public approvalData: any ) {}
}
export class IUDMatchingGiftStateSuccess implements Action {
  readonly type = MatchingGiftActionTypes.IUDMatchingGiftStateSuccess;
  constructor(public statusId: number) {}
}
export class arwMatchingGift implements Action {
  readonly type = MatchingGiftActionTypes.arwMatchingGift;
  constructor(public payload: any ) {}
}
export class arwMatchingGiftSuccess implements Action {
  readonly type = MatchingGiftActionTypes.arwMatchingGiftSuccess;
  constructor(public msg: any) {}
}

export class MatchingGiftScreenErrorReset implements Action {
  readonly type = MatchingGiftActionTypes.MatchingGiftScreenErrorReset;
}

export type MatchingGiftActions = 
  LoadInitialState
  | LoadMatchingGiftState
  | LoadMatchingGiftStateSuccess
  | LoadMatchingGiftStateFail
  | IUDMatchingGiftState
  | IUDMatchingGiftStateSuccess
  | arwMatchingGift
  | arwMatchingGiftSuccess
  | MatchingGiftScreenErrorReset;